import {brand, Branded, TypeOf} from 'io-ts';
import {PositiveInt} from '../PositiveInt';

interface CurrencyIdBrand {
    readonly CurrencyId: unique symbol;
}

export const CurrencyId = brand(PositiveInt, (n): n is Branded<PositiveInt, CurrencyIdBrand> => true, 'CurrencyId');

export type CurrencyId = TypeOf<typeof CurrencyId>;
